// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const noteKeys = {
  all: ['note'] as const,
  note: (noteId: string) => [...noteKeys.all, noteId] as const,
};

export default noteKeys;
